
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import ThumbsIcon from "../images/ThumbsIcon";
import { rateConversation } from "../../../services/chatService";
import { setRateMessageData } from "../../../features/messagesSlice";

export default function RateMessage({id, rate}) {

		const dispatch = useDispatch()

	  const token = useSelector((state) => state.session.token);
		const rateMessageData = useSelector(state => state.messages.rateMessageData);

    const [submitted, setSubmitted] = useState({
        done: false,
        type: null
    })


		const stored = rateMessageData.find(item => item.id === id);
  	const finalType = submitted.type !== null ? submitted.type : stored?.rate?.type;

    const handleRate = async (sendType, id) => {

			setSubmitted({
					done: true,
					type: sendType
			})

			const { type } = submitted

			if ( sendType === type) return false

			await rateConversation(token, sendType, id)

			const rate = {
				done: true, 
				type: sendType
			}

			const updateRateMessageData = (rateMessageData, rate, id) => {

				const exists = rateMessageData.find(item => item.id === id);
				if (exists) {
						return rateMessageData.map(item =>
							item.id === id ? { ...item, rate } : item
						);
				} else {
						return [...rateMessageData, { rate, id }];
				}
			}

			const result = updateRateMessageData(rateMessageData, rate, id)

			dispatch(setRateMessageData(result))
    }

    return (
         <div style={{display:"flex", justifyContent:"end", alignItems: "center"}}>
						<>
							<div className={`rate-container ${finalType === true ? "liked": ""}`} onClick={(e)=> handleRate(true, id)}>
									<ThumbsIcon colorStroke={finalType === true ? "#FFF" : "#000"}/>
							</div>
							<div className={`rate-container dislike ${finalType === false ? "disliked": ""}`} onClick={()=> handleRate(false, id)}>
									<ThumbsIcon colorStroke={finalType === false ? "#FFF" : "#000"}/>
							</div>
						</>
        </div>
    )
}